import { ge } from './ge'
import { uz } from './uz'
import type { MarketCode, MarketConfig } from './types'

const MARKETS: Record<MarketCode, MarketConfig> = { uz, ge }

/** Chosen at build time: each country site is its own build (VITE_MARKET). */
export const MARKET_CODE = (import.meta.env.VITE_MARKET || 'uz') as MarketCode // '' counts as unset, as in vite.config.ts

if (!(MARKET_CODE in MARKETS)) {
  throw new Error(`Unknown VITE_MARKET "${MARKET_CODE}". Expected one of: ${Object.keys(MARKETS).join(', ')}`)
}

export const MARKET: MarketConfig = MARKETS[MARKET_CODE]

export type { MarketCode, MarketConfig, LanguageOption, PartnerLogoKey } from './types'
